// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  workId: __t.u64().primaryKey().name("work_id"),
  civ: __t.string(),
  kind: __t.string(),
  aSid: __t.u64().name("a_sid"),
  bSid: __t.u64().name("b_sid"),
  progress: __t.f32(),
  target: __t.f32(),
  cost: __t.i64(),
  status: __t.string(),
  startedAt: __t.timestamp().name("started_at"),
  doneAt: __t.timestamp().name("done_at"),
});
